import Config from "@/model/Config";
import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async () => {
        const response = await httpClient.get(`/Config/listar`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (config: Config) => {
        const response = await httpClient.post(`/Config/inserir`, config);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (config: any) => {
        const response = await httpClient.post(`Config/alterar`, config);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
});